export const MISSING_URL_PROTOCOL_MESSAGE = (t) =>
  `${t('Currently missing Protocol')} (http:// or https://).`;
export const MISSING_URL_TLD_MESSAGE = (t) =>
  t('Currently missing TLD (.com, .org, etc.).');
export const FULLY_QUALIFIED_LINK_MESSAGE = (t) =>
  `${t('This must be a fully qualified URL')} (http://www.example.com) ${t(
    'to save.'
  )}`;
